var UnderstandSectionEntity = /** @class */ (function () {
    function UnderstandSectionEntity(
    //reportSummary: Array<IUnderstandSectionSubEntity>,
    reportDetails) {
        //this.reportSummary = reportSummary;
        this.reportDetails = reportDetails;
    }
    return UnderstandSectionEntity;
}());
export default UnderstandSectionEntity;
